/**
 * Apple's `wave.3.right.circle` SF Symbol, traced as SVG.
 *
 * The Tap to Pay on iPhone App Review checklist (§5.4) requires the button icon to
 * be either `wave.3.right.circle` or `wave.3.right.circle.fill` from SF Symbols —
 * no substitutes. A WKWebView cannot reference SF Symbols directly, so tracing the
 * glyph is the accepted route for a hybrid app.
 *
 * The outline variant is deliberate over `.fill`: it needs no knockout mask and so
 * inherits `currentColor` on any background. Both variants are permitted.
 */
export function TapToPayIcon({ className }: { className?: string }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.6}
            strokeLinecap="round"
            className={className}
            aria-hidden="true"
            focusable="false"
        >
            <circle cx="12" cy="12" r="10.4" />
            {/* Three right-opening arcs, concentric about (6.5, 12). */}
            <path d="M8.69 9.40 A3.4 3.4 0 0 1 8.69 14.60" />
            <path d="M10.36 7.40 A6.0 6.0 0 0 1 10.36 16.60" />
            <path d="M12.03 5.41 A8.6 8.6 0 0 1 12.03 18.59" />
        </svg>
    );
}
